import { render } from "./page_9.vue?vue&type=template&id=1a97cb54&scoped=true"
import script from "./page_9.vue?vue&type=script&lang=js"
export * from "./page_9.vue?vue&type=script&lang=js"

import "./page_9.vue?vue&type=style&index=0&id=1a97cb54&scoped=true&lang=css"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a97cb54"]])

export default __exports__